<script>
import Endpoints from '../../../../../components/common/Endpoints';
import Common from '../../../../../components/common/Common';
import Request from '../../../../../components/common/Request';

const instanceateAddress = (addressObj, geo) => {
    addressObj.name = 'MAIN';
    if (geo.geometry.lat){
        addressObj.lat = geo.geometry.lat;
    }else return null;
    if (geo.geometry.lng){
        addressObj.lng = geo.geometry.lng;
    }else return null;

    return addressObj;  
}


export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

        payload.data.company = payload.company;
        payload.filters.company = payload.company;
        payload.data.systemUser = payload.$session.get('user')._id;

        setTimeout(async function(){
            let responseCertifies = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.parts.certifies.list}`);
            if (responseCertifies.status==200){
                payload.certifies = responseCertifies.data.results;
            }
        }, 100);
    }, 
    methods:{
       search: async function(){

            let state = this;

            $('#spinner').modal('toggle');

            this.data.searchArea = state.searchArea * 1000;
            let data = JSON.parse(JSON.stringify(this.data))
            
            try {
                setTimeout(async function(){
                await Request.do(state, 'POST', Request.getDefaultHeader(state), data, `${Endpoints.orders.order}`,
                (response)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle');

                    state.flashMessage.success(
                        state.configMessage(state.$t('string.msg.fleet.driver.order.title.success'), state.$t('string.msg.fleet.driver.order.message.success'), 'top left', 6000),
                        {
                            mounted: state.showText(state.$t('string.msg.fleet.driver.order.message.success')),
                            destroyed: state.clearText()
                        })
                    state.clearForm();
                },
                (error)=>{//ERROR CALLBACK
                });
            }, 1000);
            } catch (error) {
            }
        },
         redirectToMyOrders(){
            this.$router.push({ path: '/my-orders' });
            window.location.href = "?#/my-orders";
        },
        getUserGeolocation: async function(){
            let state = this;
            setTimeout(async function(){ 
                      Request.do(state, 'POST', Request.getDefaultHeader(state), { systemUserId: state.data.trucker}, `${Endpoints.addresses.getCurrentGeolocation}`,
                (response)=>{//SUCCESS CALLBACK
                if(response.results){
                    state.data.latitude = response.results.latitude;
                    state.data.longitude = response.results.longitude;
                    console.log(state.data.latitude)
                }
                },
                (error)=>{//ERROR CALLBACK
                });
            }, 100);
        }, 
        getAddressData: function (addressData, placeResultData) {
            this.address = addressData;
        },
        checkForm: async function (e) {
            this.errors = [];

            if (!this.truckType) {
                this.errors.push(this.$t('response.orders.fleet.vehicle.required'));
            }
            if (!this.data.certified) {
                this.errors.push(this.$t('response.orders.fleet.certified.required'));
            }
              if (!this.data.systemUser) {
                this.errors.push(this.$t('response.orders.fleet.trucker.required'));
            }
            if (!this.data.description) {
                this.errors.push(this.$t('response.orders.fleet.description.required'));
            }
            if (this.searchArea == 0) {
                this.errors.push(this.$t('response.orders.fleet.search.required'));
            }
            if(!this.data.truck) {
                this.errors.push(this.$t('response.orders.fleet.truck.required'));
            }

            if (this.errors.length>0){
                e.preventDefault();
            }else{
                try {
                    await this.search();
                } catch (error) {
                    console.log(error)
                }
            }
        },
        findTruck: function(){
            let state = this;
            state.data.truck = null;
            if(state.truckType && state.truckType == 'TRUCK'){
                state.filters.vehicleTypes = state.truckTypes;
                state.filters.type = "TRUCK";
                setTimeout(async function(){ 
                    Request.do(state, 'POST', Request.getDefaultHeader(state), state.filters , `${Endpoints.trucks.listByType}`,
                    (response)=>{//SUCCESS CALLBACK
                        state.trucks = response.results;
                    },
                    (error)=>{//ERROR CALLBACK
                    return null;
                    });
                }, 100); 
            }
            else if(state.truckType && state.truckType == 'TRUCK_TRAILER'){
                state.filters.vehicleTypes = state.truckTrailerTypes;
                state.filters.type = "TRUCK_TRAILER";
                setTimeout(async function(){ 
                    Request.do(state, 'POST', Request.getDefaultHeader(state), state.filters, `${Endpoints.trucks.listByType}`,
                    (response)=>{//SUCCESS CALLBACK
                        state.trucks = response.results;
                    },
                    (error)=>{//ERROR CALLBACK
                    return null;
                    });
                }, 100); 

            }
   
        },
        clearForm: function(){
            this.data = {
                searchArea: 0,
                truck: null,
                certified: null,
                company: null,
                systemUser: null,
                trucker: null,
                description: null,
                typeOrder: "CERTIFIEDS",
                latitude: 0,
                longitude: 0,
                statusOrder: "WAITING_FOR_RESPONSE",
                isSearchByCompany: true
            };
            this.orderHolder = {};
            this.truckType = null;
            this.address= {
                state: -1,
                cep: null,
                city: null,
                address: null,
                neighborhood: null,
                number: null
            };
            this.data.company = this.$session('user').companyUser.company._id;
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },
        loadGeolocation: function (callbackSuccess, callbackError) {
            let state = this;
            Request.do(this, 'POST', Request.getDefaultHeader(this), this.address, `${Endpoints.addresses.geolocation}`,
                    (geoResponse)=>{//SUCCESS CALLBACK
                        if (geoResponse.results.length==0){
                            return callbackError(this.$t('string.company.register.address.invalid'));
                        }else if (geoResponse.results.length==1){
                            let geo = geoResponse.results[0];
                            let addressObj = instanceateAddress(state.address, geoResponse.results[0]);
                            if (addressObj){

                                this.data.latitude = addressObj.lat;
                                this.data.longitude = addressObj.lng;
                                
                                return callbackSuccess(state.address);
                            }else {
                                // state.data.address
                                return callbackError(state.$t('string.company.register.address.invalid'));
                            }
                        }else if (geoResponse.results.length>1){
                            state.addresses = geoResponse.results;
                            $('#modalListAddress').modal('toggle');
                        } 
                    },
                    (error)=>{//ERROR CALLBACK
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else if (res.data.messageId === 'response.already.exists'){
                                this.messageToast = this.$t('response.user.already.exists');
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                        
                    });        
        },
        selectAddress: function(index){
            let addressObj = instanceateAddress(this.address, this.addresses[index]);
            
            if (addressObj){
                addressObj.ibge = this.address.ibge;
                addressObj.gia = this.address.gia;
                addressObj.complement = this.address.complement;
                this.address = addressObj;
                $('#modalListAddress').modal('toggle');
                this.save(this.data);
            }else {
                this.errors = [];
                this.errors.push(this.$t('string.company.register.address.invalid'));
                 $('#modalListAddress').modal('toggle');
            }
        },
        loadInfosByCEP: function(){
            let state = this;
            if (this.address.cep && this.address.cep.length == 9){
                $('#spinner').modal('toggle');
                Request.do(this, 'GET', {}, {}, `${Endpoints.cep.find}${this.address.cep}/json`,
                    (response)=>{//SUCCESS CALLBACK
                        if (response){
                            state.address.address = response.logradouro;
                            state.address.neighborhood = response.bairro;
                            state.address.city = response.localidade;
                            state.address.state = response.uf;
                            state.address.ibge = response.ibge;
                            state.address.gia = response.gia;
                        }
                        
                        $('#spinner').modal('toggle');
                        state.loadGeolocation();

                    },
                    (error)=>{//ERROR CALLBACK
                        $('#spinner').modal('toggle');
                        console.log(JSON.stringify(error));
                });
            }
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
